import axios from "axios";

  export const consultarTasaIvaSegunInscripcion = async (tic_code: number) => {
    return axios.get(`api/facturas/ConsultarTasaIvaSegunInscripcion?tic_code=${tic_code}`)
  }

  export const consultarFacturasPresentacion = async (precupon: number) => {
    return axios.get(`api/facturas/ConsultarFacturasPresentacion?precupon=${precupon}`)
  }

  export const crearFacturaPresentacion = async ( data: any) => {
    return axios.post(`api/facturas/CrearFacturaPresentacion`,data)
      .catch(err => err);
  }

  export const actualizarFacturaPresentacion = async (data: any) => {
    return axios.post('api/facturas/ActualizarFacturaPresentacion',data)
      .catch(err => err);
  }

  export const borrarFacturaPresentacion = async (data: any) => {
      //return axios.delete('api/facturas/BorrarFacturaPresentacion', { data: data })
      return axios.post('api/facturas/BorrarFacturaPresentacion', data)
  }
  
  export const consultarTipoFacturas = async () => {
    return axios.get('api/facturas/ConsultarTipoFacturas')
  }

  export const obtenerImagenFacturas = async (fpa_nombre_imagen:string) => {
    return axios.get(`api/facturas/ObtenerImagenFacturas?nombreImagen=${fpa_nombre_imagen}`)
      .catch(err => err);
  }

export const leerFacturaPresentacionOCR = async ( data: any) => {
    return axios.post(`api/facturas/LeerFacturaPresentacion`,data)
      .catch(err => err);
  }

  export const crearFacturaPresentacionOCR = async ( data: any) => {
    return axios.post(`api/facturas/CrearFacturaPresentacionOCR`,data)
      .catch(err => err);
  }
   export const consultarFacturasPresentacionOCR = async (precupon: number) => {
    return axios.get(`api/facturas/ConsultarFacturasPresentacionOCR?precupon=${precupon}`)
  }
  export const ObtenerListadoJurisdiccion = async () => {
    return axios.get(`api/facturas/ObtenerListadoJurisdiccion`)
  }
    export const ObtenerDetalleIIBBPercepcionescomercioconfig = async () => {
    return axios.get(`api/facturas/ObtenerDetalleIIBB_Percepciones_comercio_config`)
  }